// Zdarzenia ze strumienia /events (Login/backend/server.js#broadcastSSE), po których kalendarz
// odświeża listy i otwarte okno szczegółów. Każde dotyczy rezerwacji: nowa, anulowana, wpłata,
// zwrot, kaucja zablokowana, ściągnięta albo zwolniona, wycofana prośba o płatność.
//
// Do przeglądu PR #212 kalendarz znał tylko trzy pierwsze rodzaje, więc po zablokowaniu kaucji
// przez klienta otwarte okno dalej proponowało „Wyślij link do kaucji” i „Kaucja gotówką” (serwer
// odpowiadał 409), a zwrot zaliczki w innej karcie zostawiał w oknie „(opłacona)” i starą kwotę
// „Pozostało do zapłaty”. Nowy rodzaj zdarzenia nadawany przez serwer trzeba dopisać tutaj albo
// świadomie pominąć; pilnuje tego test kompletności w __tests__/zdarzeniaSerwera.test.js.
export const ZDARZENIA_ODSWIEZAJACE_KALENDARZ = new Set([
  'reservation_created',
  'reservation_cancelled',
  'payment_paid',
  'payment_refunded',
  'payment_cancelled',
  'deposit_authorized',
  'deposit_captured',
  'deposit_released',
  // Zapytanie z widgetu o sprzęt z klas (069): dobrana sztuka albo potwierdzenie dostępności.
  'reservation_request_updated',
  // F.6: termin wpłaty ustawiony, usunięty albo przesunięty przez sweep.
  'reservation_payment_deadline',
]);

export const odswiezaKalendarz = (zdarzenie) => !!zdarzenie
  && ZDARZENIA_ODSWIEZAJACE_KALENDARZ.has(zdarzenie.type);
